// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from "@sentry/browser";
import { takeLatest } from "redux-saga/effects";

const onSetApplicationId = (action) => {
  const applicationId = action.payload;

  Sentry.setContext("application", {
    applicationId,
  });
};

const onSetFirstApplication = (action) => {
  Sentry.setTag("isFirstApplication", action.payload);
};

const onSetNewClient = (action) => {
  Sentry.setTag("isNewClient", action.payload);
};

const onSetShortForm = (action) => {
  Sentry.setTag("isShortForm", action.payload);
};

const onSetContactId = (action) => {
  const contactId =
    action.type === "SET_CONTACT_ID"
      ? action.payload
      : action.payload?.contactId;

  Sentry.setUser({
    contactId,
  });
};

const onSetAuthDataId = (action) => {
  if (!action.payload.isAuth) return;

  const user = Sentry.getGlobalScope().getUser();
  const { isOperator, displayName } = action.payload;

  Sentry.setUser({
    ...user,
    isOperator,
    displayName,
  });
};

export function* updateGlTipApplicationIdSaga() {
  yield takeLatest(["SET_APPLICATION_ID"], onSetApplicationId);
}

export function* updateGlTipIsFirstApplicationSaga() {
  yield takeLatest(["SET_IS_FIRST_APPLICATION"], onSetFirstApplication);
}

export function* updateGlTipIsNewApplicationSaga() {
  yield takeLatest(["SET_IS_NEW_CLIENT"], onSetNewClient);
}

export function* updateGlTipIsShortFormSaga() {
  yield takeLatest(["SET_IS_SHORT_FORM"], onSetShortForm);
}

export function* updateGlTipContactIdSaga() {
  yield takeLatest(["SET_AUTH_DATA", "SET_CONTACT_ID"], onSetContactId);
}

export function* updateGlTipAuthDataSaga() {
  yield takeLatest(["SET_AUTH_DATA"], onSetAuthDataId);
}
